import { render, staticRenderFns } from "./SamMenu.vue?vue&type=template&id=26cee405&scoped=true&shadow"
import script from "./SamMenu.vue?vue&type=script&lang=js&shadow"
export * from "./SamMenu.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamMenu.vue?vue&type=style&index=0&id=26cee405&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "26cee405",
  null
  ,true
)

export default component.exports